let token = null;

export const getAccessToken = () => token;
export const setAccessToken = (value) => {
  token = value;
};
export const clearAccessToken = () => {
  token = null;
};
